<template>
  <section>
    <section class="q-pa-sm">
      <div class="text-center text-h5">
        EXTRATO DE PEDIDO
      </div>
      <div>
        <div>
          DATA: {{now}}
        </div>
      </div>
      <div>
        <div>
          Número Pedido: {{pedido.numPedido}}
        </div>
      </div>
      <div>
        <div>
          CLIENTE: {{pedido.nome}}
        </div>
      </div>
      <div>
        <div>
          USINA: {{pedido.nomeFantasiaInd}}
        </div>
      </div>
      <hr style="border: 1px solid black;" />
    </section>
    <section class="q-pa-sm">
      <table class="table">
        <thead>
          <tr>
            <th>Data Pedido</th>
            <th>Data Agendamento</th>
            <th>Descrição</th>
            <th>Placa Veículo</th>
            <th>Transportadora</th>
            <th>Motorista</th>
            <th class="text-right">Peso Líquido (ton)</th>
            <th>Situacao</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, idx) of programacao" :key="idx">
            <td>{{x.pedData | date}}</td>
            <td>{{x.dataagenda | date}}</td>
            <td>{{x.prdDescricao}}</td>
            <td>{{x.veiPlaca}}</td>
            <td>{{x.respcarga}}</td>
            <td>{{x.motorista}}</td>
            <td class="text-right">{{x.pesoliquido}}</td>
            <td>{{x.situacao | uppercase}}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import moment from 'moment'
export default {
  name: 'report-programacao',
  props: {
    programacao: {
      type: Array,
      required: true
    },
    pedido: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    now () {
      return moment().format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>